<template>
  <transition name="fade">
    <div class="modal" v-if="show">
      <div class="modalOverlay"></div>
      <div :class="{modalContent: true, hasCheck: checkbox}">
        <h4 v-html="title"></h4>
        <p v-html="desc"></p>
        <div class="checkCnt" v-on:click="checked = !checked" v-if="checkbox">
          <div class="checkboxOuter">
            <div :class="{checkbox: true, checked: checked}">
              <div class="checkInner"></div>
            </div>
          </div>
          <p>{{checkbox}}</p>
        </div>
        <div class="modalAction">
          <button class="btn btnSecondary" v-on:click="close()"
            v-if="confirm">Batal</button>
          <button class="btn btnPrimary" v-on:click="close(true)">
            <span v-if="action">{{action}}</span>
            <span v-else>Hapus</span>
          </button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'confirmation',
  data() {
    return {
      show: false,
      title: '',
      desc: '',
      action: '',
      checkbox: null,
      checked: false,
      confirm: true,
      next: null,
    };
  },
  methods: {
    open(d, next) {
      this.next = next;
      this.title = d.title;
      this.desc = d.desc;
      this.checkbox = d.checkbox;
      this.action = d.action;
      this.confirm = (typeof d.confirm !== 'undefined') ? d.confirm : true;
      this.show = true;
    },
    close(b) {
      this.show = false;
      if (this.next && typeof this.next === 'function') this.next(b, this.checked);
    },
  },
};
</script>

<style scoped lang="scss">
  .modal{
    position: fixed;
    top: 0; left: 0; right: 0; bottom: 0;
    z-index: 991;
    display: flex;
    align-items: center;
    justify-content: center;
    .modalOverlay{
      position: fixed;
      top: 0; left: 0; right: 0; bottom: 0;
      background-color: rgba(0,0,0,.7);
      z-index: 1;
      // backdrop-filter: saturate(180%) blur(20px);
      opacity: 1;
    }
    .modalContent{
      position: absolute;
      background-color: #fff;
      z-index: 2;
      padding: 30px 40px;
      border-radius: 5px;
      margin-top: -20px;
      text-align: center;
      overflow: hidden;
      max-width: 420px;
      @media (max-height: 680px) {
        width: calc(100% - 20px);
        box-sizing: border-box;
        padding: 30px 16px;
      }
      &.hasCheck{
        text-align: left;
      }
      h4{
        margin: 0;
        font-size: 24px;
        font-weight: normal;
        margin-bottom: 5px;
        color: #444;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }
      p{
        margin: 0;
        color: #767676;
      }
      .checkCnt{
        margin: 20px 0 6px;
        position: relative;
        padding-left: 28px;
        cursor: pointer;
        p{
          color: red;
        }
        .checkboxOuter{
          position: absolute;
          left: -8px; top: -6px;
          width: 32px; height: 32px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          &:hover{
            background-color: #eee;
          }
          .checkbox{
            width: 14px; height: 14px;
            border-radius: 3px;
            border: #999 2px solid;
            display: flex;
            align-items: center;
            justify-content: center;
            transition: all .2s ease;
            &.checked{
              border-color: red !important;
              background-color: red !important;
              background-image: url(../assets/checked.png);
              background-size: 14px auto;
              background-position: center;
              background-repeat: no-repeat;
              .checkInner{
              }
            }
          }
        }
        &:hover{
          .checkboxOuter{
            .checkbox{
              border-color: #444;
            }
          }
        }
      }
      .modalAction{
        margin: 30px -40px -30px;
        padding: 10px 20px;
        text-align: right;
        // background-color: #eee;
        border-top: #eee 1px solid;
        @media (max-height: 680px) {
          margin: 30px -16px -30px;
        }
        .btn{
          margin-left: 10px;
          padding-top: 6px; padding-bottom: 6px;
        }
      }
    }
  }
</style>
